module.exports = __webpack_public_path__ + "static/assets/aa6708843a20b6d5052b6ea1a5b76abe.svg";